var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrendUpDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.74071 0.0279787C1.50746 0.0703147 1.33058 0.274463 1.33058 0.519923L1.33864 0.609798C1.38097 0.843048 1.58512 1.01992 1.83058 1.01992L10.523 1.01985L0.416368 11.1265L0.358513 11.1958C0.223517 11.3906 0.242802 11.6601 0.416368 11.8336C0.611631 12.0289 0.928213 12.0289 1.12348 11.8336L11.2301 1.72696L11.2301 10.4194L11.2381 10.5093C11.2805 10.7425 11.4846 10.9194 11.7301 10.9194C12.0062 10.9194 12.2301 10.6956 12.2301 10.4194L12.2301 0.519923L12.222 0.430047C12.1797 0.196798 11.9755 0.0199226 11.7301 0.0199229L1.83058 0.0199229L1.74071 0.0279787Z",
    fill: "#23252C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendUpDark);
export default __webpack_public_path__ + "static/media/trend-up-dark.9f9fd0d9ac4abb1a7a58563016ef0e27.svg";
export { ForwardRef as ReactComponent };